<div class="pa-tag-list">
  <pa-tag 
    *ngFor="let tag of processedTags" 
    (click)="$event.stopPropagation()"
    [value]="tag.label" 
    [severity]="tag.severity">
  </pa-tag>
</div> 